import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 20px 24px 20px;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.white};
  flex: 1;
  height: 100px;
`;

const Button = styled.button`
  transition: background-color 0.3s ease;
  appearance: none;
  display: block;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.colors.white};
  outline: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

export const Year = styled(Button)`
  font-size: 16px;
  margin: 0 0 14px 0;
`;

export const Date = styled(Button)`
  font-size: 24px;
  font-family: ${({ theme }) => theme.typography.primary.bold};
  margin: 0;
`;
